import $ from 'jquery';

$.addInit(function(context) {
	var base = '.b-form';
	$(base, context).validity({
		output: function(input, message) {
			var field = $(input).closest(base + '-field');
			field.toggleClass('m-error', !!message);
			field.find(base + '-error').text(message);
		}
	});
});



//////////////////
// WEBPACK FOOTER
// ./src/components/b-form.js
// module id = 14
// module chunks = 0